// extracted by mini-css-extract-plugin
var _1 = "Unsplash_alert__c3927";
var _2 = "Unsplash_footer__a67d5";
export { _1 as "alert", _2 as "footer" }
